import { createTheme } from '@mui/material'

declare module '@mui/material/styles' {
  interface Palette {
    progressBar: {
      high: string
      mid: string
      low: string
    }
    currentMonth: {
      /** Light green tint used to highlight the current month row/item. */
      tint: string
    }
  }
  interface PaletteOptions {
    progressBar?: {
      high?: string
      mid?: string
      low?: string
    }
    currentMonth?: {
      tint?: string
    }
  }
}

const mojovaTheme = createTheme({
  palette: {
    primary: {
      main: '#78a22f',
    },
    secondary: {
      main: '#727171',
    },
    background: {
      default: '#f5f5f5',
    },
    progressBar: {
      high: '#65B13A', // success green — goal on track (≥ 70%)
      mid: '#9FB037', // olive — getting there (40–69%)
      low: '#F9CC00', // yellow — needs attention (< 40%)
    },
    currentMonth: {
      tint: '#EBF7EC', // sds-brand-color-background-success — current month highlight
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
          lineHeight: '1.5',
        },
        head: {
          color: 'rgba(0, 0, 0, 0.54)',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          lineHeight: '1.15',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
        size: 'small',
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#E3EDD1',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#D4E4B8',
            },
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
        size: 'small',
      },
    },
    MuiRadio: {
      defaultProps: {
        size: 'small',
      },
    },
  },
})

export default mojovaTheme
